import { useContext, useEffect } from "react";

import type {
  Channel,
  ChannelFilters,
  ChannelSort,
  ChannelOptions,
} from "stream-chat";
import { ChannelList, useChatContext } from "stream-chat-react";

import { MobileContext } from "../../context/MobileContext";
import { TeamChannelPreview } from "../TeamChannelPreview/TeamChannelPreview";
import "./ChannelListContainer.css";

interface ChannelListContainerProps {
  filters: ChannelFilters;
  sort: ChannelSort;
  options: ChannelOptions;
  channelRenderFilterFn: (channels: Channel[]) => Channel[];
}

export const ChannelListContainer = ({
  filters,
  sort,
  options,
  channelRenderFilterFn,
}: ChannelListContainerProps) => {
  const { channel } = useChatContext();
  const { setIsMobileListVisible } = useContext(MobileContext);

  useEffect(() => {
    if (channel) {
      setIsMobileListVisible(false);
    }
  }, [channel, setIsMobileListVisible]);

  return (
    <div className="channel-list__container">
      <div className="channel-list__list__wrapper">
        <div className="channel-list__group">
          <ChannelList
            channelRenderFilterFn={channelRenderFilterFn}
            filters={filters}
            options={options}
            sort={sort}
            Preview={TeamChannelPreview}
          />
        </div>
      </div>
    </div>
  );
};
